import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import { Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LessonNavigationProps } from '../../../models/lessons'

export const LessonNavigation = ({
  lesson,
  course,
  isFirstLesson,
  isLastLesson,
  showFinishButton,
  onChangeLesson,
  onFinishLesson
}: LessonNavigationProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid item sx={{ gap: 1, display: 'flex', justifyContent: 'flex-end' }} xs={12} sm={6}>
      {!isFirstLesson && (
        <Button
          sx={[
            course.visibility === 1 && {
              border: `2px solid #D5B385`,
              borderRadius: 8,
              '& span': {
                backgroundImage: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                '& svg': {
                  color: `#D5B385`
                }
              },
              '&:hover': {
                '& span': {
                  WebkitTextFillColor: 'inherit',
                  color: 'grey.50',
                  '& svg': {
                    color: 'grey.50'
                  }
                },
                border: 0,
                backgroundColor: 'none',
                background: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)'
              },
              marginTop: { xs: 3 },
              width: { sx: '100%' },
              maxWidth: { xs: '100%' }
            }
          ]}
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIos />}
          onClick={() => onChangeLesson(lesson.order - 1)}
        >
          {t('previous')}
        </Button>
      )}

      {isLastLesson ? (
        <Button
          id="course-lesson-btn-finish"
          sx={[
            { display: showFinishButton ? 'block' : 'none' },
            course.visibility === 1 && {
              backgroundColor: 'none',
              background: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
              marginTop: { xs: 3 },
              width: { sx: '100%' },
              maxWidth: { xs: '100%' }
            }
          ]}
          variant="contained"
          color="primary"
          onClick={onFinishLesson}
        >
          {t('admin.courses.finish-course')}
        </Button>
      ) : (
        <Button
          sx={[
            course.visibility === 1 && {
              backgroundColor: 'none',
              background: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
              marginTop: { xs: 3 },
              width: { sx: '100%' },
              maxWidth: { xs: '100%' }
            }
          ]}
          id="course-lesson-btn-next"
          variant="contained"
          color="primary"
          endIcon={<ArrowForwardIos />}
          onClick={() => onChangeLesson(lesson.order + 1)}
        >
          {t('next')}
        </Button>
      )}
    </Grid>
  )
}
